export function operacaoDiagnosticoInRequest(params = {}) {
  return {
    type: '@operacaodiagnostico/OPERACAODIAGNOSTICO_IN_REQUEST',
    payload: { params },
  };
}

export function failedRequest() {
  return {
    type: '@operacaodiagnostico/FAILED_REQUEST',
  };
}

export function successInRequest(
  operacaodiagnostico,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaodiagnostico/SUCCESS_IN_REQUEST',
    payload: {
      operacaodiagnostico,
      page,
      pageSize,
      totalCount,
      totalPages,
    },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaodiagnostico/RECORD_FILTERING',
    payload: { params },
  };
}
